import { Injectable } from '@angular/core';
import { from, Subject } from 'rxjs';

/**
 * Message bus service services and components can subscribe to.
 * Makes application flow easier as we basically have a single source of truth.
 */
@Injectable()
export class BusService {
  listeners;
  eventsSubject;
  events;

  constructor() {
    this.listeners = {}; // list of current(subscribed) events
    this.eventsSubject = new Subject();

    this.events = from(this.eventsSubject);

    this.events.subscribe(({ name, args }) => {
      if (this.listeners[name]) {
        for (const listener of this.listeners[name]) {
          const myThis = listener.boundContext;
          if (listener.boundContext) {
            listener.call(myThis, ...args);
          } else {
            listener(...args);
          }
        }
      }
    });
  }

  /**
   * Subscribe to an event.
   */
  subscribe(name: string, listener, context?) {
    if (context) {
      listener.boundContext = context;
    }
    if (!this.listeners[name]) {
      this.listeners[name] = [];
    }
    this.listeners[name].push(listener);
  }

  /**
   * Remove a listener from an event.
   */
  unsubscribe(name: string, listener) {
    const listeners = this.listeners[name];
    if (listeners) {
      const index = listeners.indexOf(listener);
      listeners.splice(index, 1);
    }
  }

  /**
   * Publish to an event.
   */
  publish(name: string, ...args) {
    this.eventsSubject.next({
      name,
      args,
    });
  }
}
